<span bottom
      [class]="'bar-button'"
      [pTooltip]="buttonTitle|translate"
      (click)="op.toggle($event)">
    <i [class]="'icon-rtr-part1 bar-button-ico fa-solid fa-filter-circle-dollar'"></i>
    <i [class]="'icon-rtr-part2 bar-button-ico fa-solid fa-pen'"></i>
    <div class="bar-button-text">{{buttonTitle|translate}}</div>
  </span>
<p-overlayPanel #op [showCloseIcon]="true" [style.width]="'60vw'" [style.minWidth]="'60vw'" [style.maxWidth]="'60vw'"
                [dismissable]="true" [styleClass]="'top-overlay'">
  <ng-template pTemplate>
    <app-report-total-residual-form class="archive-report-total-residual-button"
                           ></app-report-total-residual-form>
  </ng-template>
</p-overlayPanel>
